<template>
  <slot />
</template>

<script setup lang="ts">
declare global {
  interface Window {
    qonfiInstances: any
    initQonfi: any
  }
}

const scriptId = 'qonfi-script'
const { initiatedThirdParty } = useApp()

watch(initiatedThirdParty, () => {
  initScript()
})

function initScript() {
  if (!initiatedThirdParty.value) {
    return
  }

  if (!document?.getElementById(scriptId)) {
    const script = document.createElement('script')
    script.async = true
    script.id = scriptId

    script.src = `https://platform.getqonfi.com/build-wizard3/wizard3.js`

    document.body.appendChild(script)
  }
}

function destroyQonfi() {
  document?.getElementById(scriptId)?.remove()

  if (window.qonfiInstances) {
    delete window.qonfiInstances
  }

  if (window.initQonfi) {
    delete window.initQonfi
  }
}

onMounted(() => {
  initScript()
})

onUnmounted(() => {
  destroyQonfi()
})
</script>
